import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

export default function Footer() {
  const currentYear = new Date().getFullYear();
  const { t } = useLanguage();

  return (
    <footer className="bg-brand-navy text-slate-300 border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand Column */}
          <div className="space-y-4">
            <div className="flex flex-col">
              <span className="font-serif text-xl font-bold text-white tracking-tight leading-none">
                NNC Revision
              </span>
              <span className="font-sans text-xs font-bold text-brand-gold tracking-wider mt-0.5">
                LTD
              </span>
            </div>
            <p className="text-sm text-slate-400 max-w-xs">
              {t('welcomeText2')}
            </p>
          </div>

          {/* Navigation Links Column */}
          <div>
            <h4 className="text-white font-serif font-semibold text-sm uppercase tracking-wider mb-4">
              {t('quickLinks')}
            </h4>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link to="/stiftelse-af-selskaber" className="hover:text-white transition-colors cursor-pointer">
                  {t('incorporation')}
                </Link>
              </li>
              <li>
                <Link to="/koeb-og-salg-af-ejendomme" className="hover:text-white transition-colors cursor-pointer">
                  {t('properties')}
                </Link>
              </li>
              <li>
                <Link to="/koeb-og-salg-af-virksomheder-i-ind-og-udland" className="hover:text-white transition-colors cursor-pointer">
                  {t('companies')}
                </Link>
              </li>
              <li>
                <Link to="/investeringer-i-virksomheder" className="hover:text-white transition-colors cursor-pointer">
                  {t('investments')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Column */}
          <div>
            <h4 className="text-white font-serif font-semibold text-sm uppercase tracking-wider mb-4">
              {t('contactTitle')}
            </h4>
            <ul className="space-y-3 text-sm text-slate-400">
              <li>
                <span className="text-xs text-slate-500 block uppercase tracking-wider">Tlf.:</span>
                <a href="tel:+4575722337" className="text-slate-300 hover:text-brand-gold transition-colors font-medium whitespace-nowrap">
                  +45 75 72 23 37
                </a>
              </li>
              <li>
                <span className="text-xs text-slate-500 block uppercase tracking-wider">Mobil:</span>
                <a href="tel:+4540731267" className="text-slate-300 hover:text-brand-gold transition-colors font-medium whitespace-nowrap">
                  +45 40 73 12 67
                </a>
              </li>
              <li>
                <span className="text-xs text-slate-500 block uppercase tracking-wider">E-mail:</span>
                <a href="mailto:nncrevision@nncrevision.dk" className="text-slate-300 hover:text-brand-gold transition-colors font-medium whitespace-nowrap">
                  nncrevision@nncrevision.dk
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-slate-800 flex flex-col sm:flex-row justify-between items-center gap-4 text-xs text-slate-500">
          <p>
            &copy; {currentYear} NNC Revision Ltd. {t('rightsReserved')}
          </p>
          <div className="flex gap-6">
            <span className="text-slate-600">{t('cvrNotDisclosed')}</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
